import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
import { sizeViewboxes } from '../../constants';
const DashIcon = ({ size, ...rest }) => {
    const paths = {
        '16px': _jsx("path", { d: "M3 8H13", stroke: "currentColor", strokeWidth: "1.33333", strokeLinecap: "round" }),
        '24px': _jsx("path", { d: "M4 12H20", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
        '32px': (_jsx("path", { d: "M5 16L27 16", stroke: "currentColor", strokeWidth: "2.66667", strokeLinecap: "round" })),
    };
    return (_jsx(Svg, { fill: "none", size: size, viewBox: sizeViewboxes[size], ...rest, children: paths[size] }));
};
export default DashIcon;
//# sourceMappingURL=DashIcon.js.map